var host_name = window.location.hostname,
    path_name = window.location.pathname,
    host = window.location.href;

  
var searchParams = new URLSearchParams(window.location.search);

if ( !searchParams.has("noredirect") ) {
  // redirect the products if our path contains en-us
  if ( host.includes("us.integricare.ca/products/") && path_name.substr(path_name.length - 3) != "-us" ) {
      host = host.replace(/\/$/, "");
      window.location.replace(host + "-us");
  } else if ( !host.includes("us.integricare.ca/products/") && path_name.substr(path_name.length - 3) == "-us")  {
      window.location.replace( host.slice(0, -3) )
  }

  if ( localizationISO == 'CA' && path_name.includes('/collections/en-us') )  {
      window.location.replace('https://integricare.ca/collections/en-ca/');
  } else if ( localizationISO == 'US' && path_name.includes('/collections/en-ca') )  {
      window.location.replace('https://us.integricare.ca/collections/en-us/');
  }

  // let's get rid of the all collections page
  if ( host.includes('us.integricare.ca/collections/all') ) {
      window.location.replace('https://us.integricare.ca');
  } else if ( host.includes('https://integricare.ca/collections/all') ) {
      window.location.replace('https://integricare.ca');
  }

  // redirect the opposite collection based on the localization variable
  if (localizationISO == 'CA' && host.includes('us.integricare.ca/collections/all') ) {
      window.location.replace('https://us.integricare.ca/');
  } else if (localizationISO == 'US' && host.includes('https://integricare.ca/collections/all') ) {
      window.location.replace('https://integricare.ca/');
  }

  // set a cookie
  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  // get a cookie
  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  // process the geolocation data
  function geoLocation(data) {

    if (data) {
      var iso = data.country;
      setCookie('integricareLoc', iso, 1)
    } else {
      var iso = getCookie('integricareLoc');
    }
    local = localizationISO;

    let html = document.querySelector('html');
    html.classList.add(iso + '-user');

    if (iso == 'CA' && local != 'CA') {
        window.location.replace('https://integricare.ca/');
    } else if (iso == 'US' && local != 'US') {
        window.location.replace('https://us.integricare.ca/');
    } 
    
  }

  // do the geolocation (no bots)
  if (!navigator.userAgent.match(/bot|spider/i)) {
    if ( !getCookie('integricareLoc') ) {
      fetch('https://ipinfo.io/json?token=c53b7ef05a582a')
      .then(res => res.json())
      .then(data => geoLocation(data) )
    } else {
      geoLocation(false);
    }
  }
}